import {useEffect} from 'react';
import {fadeOutCityCapturePanels} from '../../components/gameUi/cityCapturePanelsFade';
import {CITY_CAPTURE_ANIMATION} from '../../configs/cityCaptureAnimation';

/**
 * Пока идет облет захваченных городов, панели, открытые к его началу, погашены
 * (см. components/gameUi/cityCapturePanelsFade); облет кончился — вернулись
 * @param {boolean} isCityCaptureAnimationPlaying
 * @param {ParentNode|null} root - корень экрана матча
 */
export const useCityCapturePanelsFade = (isCityCaptureAnimationPlaying, root) => {
  useEffect(() => {
    if (!isCityCaptureAnimationPlaying || !root) {
      return undefined;
    }
    return fadeOutCityCapturePanels(root, CITY_CAPTURE_ANIMATION.panelsFadeMs);
  }, [isCityCaptureAnimationPlaying, root]);
};
